export default class JustificationFile {
  id: string;

  extensionFile: string;

  fileName: string;

  file: string;

  contentType: string;

  constructor(obj: any = {}) {
    this.id = obj.id || null;
    this.extensionFile = obj.extensionFile || '';
    this.fileName = obj.fileName || '';
    this.file = obj.file || null;
    this.contentType = obj.contentType || '';
  }
}
